<template>
  <div class="nix-confirm-card">
    <div class="text-center" v-if="success">
      <i class="nix-confirm-card__icon-success fa-light fa-circle-check"></i>
      <div class="nix-confirm-card__title">{{ title }} confirmado com sucesso!</div>
      <div class="nix-confirm-card__link" @click="navegateToLogin">Efetuar login</div>
    </div>

    <div class="text-center" v-if="error">
      <i class="nix-confirm-card__icon-error fa-solid fa-circle-xmark"></i>
      <div class="nix-confirm-card__title">Solicitação expirada!</div>
    </div>

    <Loading :center="false" v-show="loading" />
  </div>
</template>

<script>
import Loading from '@/ui/shared/Loading.vue'
import { authService } from '@/modules/auth/services/auth.service'

export default {
  name: 'ConfirmMailMobileCard',
  components: { Loading },
  data() {
    return {
      loading: true,
      success: false,
      error: false,
      route: this.$route.path,
    }
  },
  created() {
    this.confirm()
  },
  computed: {
    title() {
      return this.isMobile ? 'WhatsApp' : 'E-mail'
    },
    isMobile() {
      return this.route.includes('mobile')
    },
  },
  methods: {
    async confirm() {
      try {
        await authService.confirmMailMobile({
          codeConfirmedEmailMobile: this.$route.params.code,
          typeConfirm: this.isMobile ? 'mobile' : 'email',
        })
        this.success = true
      } catch (e) {
        // `api` rejeita quando success=false, então a expiração cai aqui
        this.error = true
      } finally {
        this.loading = false
      }
    },
    navegateToLogin() {
      this.$router.replace(this.$route.query.redirect || '/login')
    },
  },
}
</script>

<style scoped>
.nix-confirm-card {
  padding: 60px 20px;
}

.nix-confirm-card__title {
  margin: 10px;
  font-size: 18px;
  color: var(--text-primary);
}

.nix-confirm-card__link {
  margin-top: 18px;
  margin-bottom: 5px;
  font-size: 15px;
  cursor: pointer;
  color: var(--color-brand);
}

.nix-confirm-card__link:hover {
  color: var(--color-brand-hover);
  text-decoration: underline;
}

.nix-confirm-card__icon-success {
  font-size: 50px;
  color: #38a169;
}

.nix-confirm-card__icon-error {
  font-size: 50px;
  color: red;
}
</style>
